"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchedAirportsHandler = void 0;
const airport_1 = require("../http/airport");
const searchHelpers_1 = require("../services/searchHelpers");
const getSearchedAirportsHandler = (inputValue, callback) => {
    if (inputValue.length >= 2) {
        (0, airport_1.getSearchedAirports)(inputValue).then((response) => {
            const options = response.map(airport => (0, searchHelpers_1.mapAirportToOption)(airport));
            callback(options);
        });
    }
    else
        callback([]);
};
exports.getSearchedAirportsHandler = getSearchedAirportsHandler;
